(function () {
  const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  // Mirrors Dawn's own cart section-swapping map.
  const SECTIONS = [
    { section: 'main-cart-items',  targetId: 'main-cart-items',  selector: '.js-contents' },
    { section: 'main-cart-footer', targetId: 'main-cart-footer', selector: '.js-contents' },
    { section: 'cart-icon-bubble', targetId: 'cart-icon-bubble', selector: '.shopify-section' },
    { section: 'cart-drawer',      targetId: 'CartDrawer',       selector: '.drawer__inner' },
  ];

  function activeSections() {
    return SECTIONS.filter((s) => document.getElementById(s.targetId));
  }

  async function post(path, payload) {
    const active = activeSections();
    payload.sections = active.map((s) => s.section).join(',');
    payload.sections_url = window.location.pathname;

    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return { state: await res.json(), active };
  }

  function render({ state, active }) {
    if (!state.sections) return window.location.reload();
    active.forEach(({ section, targetId, selector }) => {
      const html = state.sections[section];
      const container = document.getElementById(targetId);
      if (!html || !container) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      const target = container.querySelector(selector) || container;
      target.innerHTML = parsed ? parsed.innerHTML : html;
    });
    document.dispatchEvent(new CustomEvent('gift-box:updated'));
  }

  const addGiftBox = (id) => post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  const changeLine = (key, quantity) => post('/cart/change.js', { id: key, quantity: quantity });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gift-box-action]');
    if (!button || button.disabled) return;

    const wrapper = button.closest('[data-gift-box-upsell]');
    if (!wrapper) return;

    event.preventDefault();

    const action = button.dataset.giftBoxAction;
    const quantity = Number(wrapper.dataset.quantity || 0);
    const lineKey = wrapper.dataset.lineKey;

    wrapper.classList.add('is-loading');
    wrapper.querySelectorAll('[data-gift-box-action]').forEach((b) => (b.disabled = true));

    try {
      let result;
      if (action === 'add' || !lineKey) {
        result = await addGiftBox(wrapper.dataset.variantId);
      } else if (action === 'increase') {
        result = await changeLine(lineKey, quantity + 1);
      } else if (action === 'decrease') {
        result = await changeLine(lineKey, Math.max(quantity - 1, 0));
      } else if (action === 'remove') {
        result = await changeLine(lineKey, 0);
      }
      if (result) render(result);
    } catch (err) {
      console.error('[gift-box-upsell]', err);
      window.location.reload();
    }
  });

  async function autoRemove() {
    const stale = document.querySelector('[data-gift-box-autoremove]');
    if (!stale || !stale.dataset.lineKey) return;
    stale.removeAttribute('data-gift-box-autoremove'); // guard against re-entry
    try {
      render(await changeLine(stale.dataset.lineKey, 0));
    } catch (err) {
      console.error('[gift-box-upsell]', err);
    }
  }

  document.addEventListener('DOMContentLoaded', autoRemove);
  document.addEventListener('gift-box:updated', autoRemove);
})();